export default __webpack_public_path__ + "static/media/Wordpress.50a69b8b.png";